import { DIVISION_KINDS } from 'cpool-constants';
import { z } from 'zod';

// same charset and length as generateDivisionId
export const divisionId = z.string().regex(/^[0-9A-Z]{6}$/);
export const divisionName = z.string().trim().min(1);
export const divisionKind = z.nativeEnum(DIVISION_KINDS);
export const divisionPhoneNumberId = z.string().min(1);
export const divisionWhatsappPhoneNumber = z.object({
    phoneNumber: z.string().trim().min(1),
    phoneNumberId: divisionPhoneNumberId.trim().regex(/^\d+$/),
});
export type DivisionWhatsappPhoneNumber = z.infer<typeof divisionWhatsappPhoneNumber>;
export const divisionWhatsappPhoneNumbersResponse = z.array(divisionWhatsappPhoneNumber);
export type DivisionWhatsappPhoneNumbersResponse = z.infer<typeof divisionWhatsappPhoneNumbersResponse>;
